import Select from '../../../components/select/Select';
import { useAuth } from '../../../context/AuthContext';
import { useTranslation } from '../../../context/translationContext';
import { UserProfileChangePasswordForm } from '../../../forms/UserProfile/UserProfileChangePasswordForm';
import { UserProfileForm } from '../../../forms/UserProfile/UserProfileForm';
import { LangTranslated } from '../../../types/core/language';
import { convertArrayToObjArray } from '../../../utils/functions/data.functions';
import http from '../../../api/axios';
import { toast } from 'react-toastify';
import { apiUrl } from '../../../api/apiUrl';
import { handleApiErrors } from '../../../api/apiErrorHandler';
import { Values } from '../../../forms/UserProfile/UserProfileForm.types';
import { useLoading } from '../../../context/loadingContext';

/**
 * Page component for user setting
 * user credentials form
 * user change password form
 */
export const UserProfileUpdatePage = () => {
  const { t, changeLang, lang, langSetting } = useTranslation();
  const { user, refreshUser } = useAuth();
  const { startLoading, stopLoading } = useLoading();
  /**
   * Change user´s credentials
   */
  const handleChangeUserCredentials = async (data: Values) => {
    try {
      startLoading();
      const response = await http.apiPost({
        url: `${apiUrl.CHANGE_CREDENTIALS}`,
        data: { ...data },
      });
      if (response?.status === 204) {
        stopLoading();
        refreshUser();
        toast.success('Success!');
      }
    } catch (err) {
      stopLoading();
      handleApiErrors(err);
    }
  };

  return (
    <>
      <h1 className="text-3xl font-bold">{t('page.user-setting.headline')}</h1>
      {langSetting && (
        <div className="w-1/6 flex items-center">
          <>
            <label className="mr-5">{t('page.user-setting.input-language')}</label>
            <Select
              data={convertArrayToObjArray(langSetting?.supportedDocLanguages, LangTranslated, t)}
              labelKey="name"
              valueKey="value"
              value={lang}
              onChange={(lang) => changeLang(lang.value)}
              className={`shadow-none w-full`}
            />
          </>
        </div>
      )}
      <div className="flex">
        <div className="w-1/3">
          <h1 className="text-3xl font-bold">{t('page.user-setting.user-credentials')}</h1>
          <UserProfileForm
            initialValues={{
              email: user?.email,
              firstName: user?.firstName,
              lastName: user?.lastName,
              phoneNumber: user?.phoneNumber,
            }}
            onSubmit={handleChangeUserCredentials}
          />
        </div>
        <div className="w-1/3 ml-10">
          <h1 className="text-3xl font-bold">{t('page.user-setting.change-password')}</h1>
          <UserProfileChangePasswordForm />
        </div>
      </div>
    </>
  );
};
